import React from 'react';
import { CurrencyType } from 'src_common/common/amount/website-money/currency';
import {
    MultiplesColumnIdType,
    MultiplesSelectionsType,
} from 'src/domains/sportsbook/trading/view/Liabilities/LiabilitiesWidgets/LiabilitiesWidgetTable/LiabilitiesWidgetTable.types';
import { observer } from 'src/utils/mobx-react';
import { MultiplesColumns } from 'src/domains/sportsbook/trading/view/Liabilities/LiabilitiesWidgets/LiabilitiesWidgetTable/LiabilitiesWidgetTable.consts';
import {
    getMultiplesRowClassName,
    getSortIndicator,
} from 'src/domains/sportsbook/trading/view/Liabilities/LiabilitiesWidgets/LiabilitiesWidgetTable/LiabilitiesWidgetTable.helpers';

type MultiplesTablePropsType = {
    sortColumn: string;
    sortDirection: string;
    handleColumnSort: (column: MultiplesColumnIdType) => void;
    selections: MultiplesSelectionsType;
    columns: Array<MultiplesColumnIdType>;
    currency: CurrencyType;
    eventId: number;
};

export const MultiplesTable = observer(
    'LiabilitiesMultiplesTable',
    ({
        sortColumn,
        sortDirection,
        handleColumnSort,
        selections,
        columns,
        currency,
        eventId,
    }: MultiplesTablePropsType): JSX.Element => (
        <table className='table__striped liabilities-table'>
            <thead>
                <tr>
                    {columns.map((col) => {
                        const longName = MultiplesColumns[col].label;
                        const abbr = 'abbr' in MultiplesColumns[col] ? MultiplesColumns[col].abbr : longName;

                        return (
                            <th
                                key={col}
                                title={longName}
                                onClick={(): void => handleColumnSort(col)}
                            >
                                {abbr}
                                {getSortIndicator(col, sortColumn, sortDirection)}
                            </th>
                        );
                    })}
                </tr>
            </thead>
            <tbody>
                {selections.map((selection) => (
                    <tr
                        key={selection.id}
                        id={selection.id}
                        className={getMultiplesRowClassName(selection)}
                        data-test-selection-id={selection.id}
                    >
                        {columns.map((col) => {
                            const routeContent = MultiplesColumns[col].route;
                            return (
                                <td
                                    key={col}
                                    data-test-column-id={col}
                                >
                                    {routeContent === undefined
                                        ? MultiplesColumns[col].cell(selection, currency)
                                        : routeContent(selection, currency, eventId)}
                                </td>
                            );
                        })}
                    </tr>
                ))}
            </tbody>
        </table>
    )
);
